import { Building2, Compass, Landmark, Users, UsersRound } from "lucide-react";
import type { LucideIcon } from "lucide-react";

const STATS: { icon: LucideIcon; value: string; label: string }[] = [
  { icon: Landmark, value: "2,500+", label: "Tourist Places" },
  { icon: Compass, value: "1,200+", label: "Heritage Sites" },
  { icon: Building2, value: "5,000+", label: "Hotels & Stays" },
  { icon: Users, value: "3,000+", label: "Verified Guides" },
  { icon: UsersRound, value: "10L+", label: "Active Travelers" },
];

export default function StatsBar() {
  return (
    <section className="bg-white pt-16">
      <div className="container-page">
        <div className="grid grid-cols-2 gap-4 rounded-2xl bg-lavender px-6 py-6 sm:grid-cols-3 lg:grid-cols-5">
          {STATS.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.label} className="flex items-center gap-3">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-white text-iris-500 shadow-sm">
                  <Icon size={20} strokeWidth={1.8} />
                </span>
                <div>
                  <div className="font-display text-xl font-bold text-navy-900">
                    {s.value}
                  </div>
                  <div className="text-xs text-slate-500">{s.label}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}